import React from 'react'
import {connect} from 'react-redux'
import * as ProjectsAction from '../actions/ProjectActions'
import {Button, Clearfix, Glyphicon} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import * as ClientsAction from "../actions/ClientActions";
import * as EntryActions from "../actions/EntryActions";
import Loading from "../components/Loading";
import TaskTable from "../components/TaskTable";
import * as utils from "../utils";
import * as TaskActions from "../actions/TaskActions";
import * as UserActions from "../actions/UserActions";
import queryString from 'query-string';
import {ALL_TIME_TEXT_URL} from "../constants";

class ProjectPage extends React.Component{

    constructor(){
        super();

        this.state = {
            waitingToExport: false
        };
    }

    componentWillMount(){
        this.loadData();
    }

    componentDidUpdate(){
        this.loadData();

        if(this.state.waitingToExport && this.props.entries.isFetched.export && this.props.tasks.isFetched.export && this.props.users.fetched){
            this.setState({waitingToExport: false});
            this.exportData();
        }
    }

    loadData(){
        if(!this.props.match || !this.props.match.params.project_id){
            this.props.history.push("/projects");
            return;
        }

        const project_id = this.props.match.params.project_id;

        this.props.fetchProjectsIfNeeded();
        this.props.fetchClientsIfNeeded();
        this.props.setActiveProject(project_id);
    }

    fetchEntriesToExport(){
        const project_id = this.props.match.params.project_id;

        this.setState({waitingToExport: true});
        this.props.fetchEntriesIfNeeded(project_id, "export");
        this.props.fetchUsersIfNeeded();
        this.props.fetchTasksIfNeeded(project_id, "export");
    }

    exportData(){
        const {entries, tasks, users, clients, projects} = this.props;


        const entryArray = Object.values(entries.items);

        utils.exportEntries(this.props.project.name, entryArray, tasks, users, clients, projects);
    }

    onTaskClick(task){
        this.props.history.push("/tasks/" + task.project.id + "/task/" + task.id)

    }
    toReporting(e, task) {
        e.preventDefault();
        e.stopPropagation();
        this.props.history.push({
            pathname: "/reporting",
            search: queryString.stringify({
                client: task.client.id,
                project: task.project.id,
                task: task.id,
                from: ALL_TIME_TEXT_URL,
                to: ALL_TIME_TEXT_URL,
            })
        });
    }

    render(){
        const {projects, project, clients, tasks} = this.props;
        const project_id = this.props.match.params.project_id;
        // const entryArray = Object.values(entries.items).filter(entry => entry.project.id === project_id);
        const taskArray = Object.values(tasks.items).filter(task => task.project.id === project_id);

        const client = project && clients.items[project.client.id];

        return projects.fetched && project ? (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">

                        <span className="visible-xs">
                            {project.name}
                            <small>&nbsp;{client.name}</small>
                            <Clearfix />
                        </span>
                        <span className="hidden-xs">
                            {project.name}
                        </span>

                        <NavLink to={"/projects/"+project.id+"/edit"} className="pull-right">
                            <Button  bsStyle="primary">
                                <Glyphicon glyph="edit"/>&nbsp;
                                Edit
                            </Button>
                        </NavLink>
                        <NavLink to={"/tasks/"+project.id} className="pull-right" style={{marginRight: "10px"}}>
                            <Button  bsStyle="default">
                                <Glyphicon glyph="tags"/>&nbsp;
                                Tasks
                            </Button>
                        </NavLink>
                        <Button bsStyle="default" className="pull-right"  style={{marginRight: "10px", marginTop: "2px"}} onClick={this.fetchEntriesToExport.bind(this)}>
                            <Glyphicon glyph="download"/>&nbsp;
                            Export
                        </Button>
                        <Clearfix />

                        <Loading right loading={this.props.entries.isFetching.export}/>
                    </h1>
                </div>
                {taskArray.length > 0 ? (
                    <TaskTable
                        tasks={taskArray}
                        project={project}
                        onItemClick={this.onTaskClick.bind(this)}
                        toReportingClick={this.toReporting.bind(this)}
                        />
                ):(
                    <div className="card-body">
                        <p>This project has no tasks yet. Click on the tasks button above to add a new task to this project.</p>
                    </div>
                )}
            </div>
        ) : (
            <Loading loading={true} center />
        );
    }
}

export default connect(state => ({
    projects: state.projects,
    project: state.projects.active,
    clients: state.clients,
    entries: state.entries,
    tasks: state.tasks,
    user: state.users.active,
    users: state.users
}), dispatch => ({
    fetchProjectsIfNeeded: () => dispatch(ProjectsAction.fetchProjectsIfNeeded()),
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded()),
    fetchEntriesIfNeeded: (project, tag) => dispatch(EntryActions.fetchEntriesIfNeeded({project}, tag || project)),
    setActiveProject: project => dispatch(ProjectsAction.setActiveProject(project)),
    fetchTasksIfNeeded: (project, tag) => dispatch(TaskActions.fetchTasksIfNeeded(project, tag || project)),
    fetchUsersIfNeeded: () => dispatch(UserActions.fetchUsersIfNeeded()),
}))(ProjectPage);


// WEBPACK FOOTER //
// ./src/pages/ProjectPage.js